import { CircularProgress, Dialog } from '@material-ui/core';
import PageContainer from 'layout/components/PageContainer';
import PageHeader from 'layout/components/PageHeader';
import moment from 'moment';
import { useCallback, useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import ViajeTrasladoBaseFilters from '../../viajeTraslado/components/ViajeTrasladoBaseFilters';
import ViajeTrasladoResumenModal from '../../viajeTraslado/components/ViajeTrasladoResumenModal';
import { useTransferReservationStore } from '../../viajeTraslado/services/TransferReservationSingleStore';
import { ViajeTrasladoGestionTable } from '../components/ViajeTrasladoGestionTable';
import { TransferReservationManagmentModel } from '../models/TransferReservationManagment';
import { TransferReservationManagementListModel } from '../models/TransferReservationManagementList';
import { ViajeTrasladosGestionEstado } from '../../viajeTraslado/models/TransferReservationPartial';
import ViajeTrasladoInfoCancelado from '../components/ViajeTrasladoInfoCancelado';
import EditLLTPais from '../components/EditLLTPais';
import DownloadTravelsXlsx from '../components/DownloadTravelsXlsx';
import { BusType } from '../../viajeTraslado/models/TransferReservation';
import BusesPreAssignModal from '../../coordinar/components/buses/pre-assign/BusesPreAssignModal';
import useChoferes from 'app/chofer/services/ChoferService';
import { useSuperQuery } from '@vadiun/react-hooks-legacy';
import { ChoferPartialModel } from 'app/chofer/models/Chofer';
import { ViajeTrasladoTipoServicio } from '../../viajeTraslado/models';
import { useSnackbar } from 'notistack';
import { createTableScrollHandler } from 'utils/tableUtils';
import DriverCanWorkDetails from 'app/chofer/components/DriverCanWorkDetails';
import { useViajesTraslado } from 'app/viaje/services';
import { useGestionReserves } from '../hooks/useGestionReserves';
import FiltersDrawer from 'shared/components/filters/FiltersDrawer';
import { columnsLabels, getDefaultFilters } from '../hooks/useGestionReserves';
import RefreshList from 'shared/components/Table/Refresh';
import SearchList from 'shared/components/Table/Search';
import FiltersButton from 'shared/components/Table/FiltersButton';
import ColumnSelector from '../../../../../shared/components/Table/actions-buttons/ColumnSelector';
import ChipsBar from 'shared/components/filters/ChipsBar';
import TableToolbar from 'shared/components/Table/TableToolbar';
import Button from 'shared/components/Button';

const ViajeTrasladoGestionPage = () => {
  const tableRef = useRef<HTMLDivElement>(null);
  const ViajeTrasladoService = useViajesTraslado();
  const snackbar = useSnackbar();
  const detailRequest = useRef(0);
  const [loadingDetail, setLoadingDetail] = useState(false);
  const mounted = useRef(true);
  const {
    gestionReserves,
    reload,
    filters,
    columnVisibility,
    setColumnVisibility,
    onFiltersChange,
    onSearchChange,
    onChangePage,
    onChangeRowsPerPage,
    onSortChange
  } = useGestionReserves();
  /*
  !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
  !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
  !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

  Mucho de este componente esta copiado en ViajeTrasladoMapPage.
  Si se hace algun cambio revisar que no se tenga que hacer tambien en ViajeTrasladoMapPage.

  !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
  !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
  !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
  */
  const transferReservationCopy = useTransferReservationStore();
  const [showFilters, setShowFilters] = useState(false);

  const [driverDetail, setDriverDetail] = useState<{
    isOpen: boolean;
    details: ChoferPartialModel | undefined;
    busVehicle?: any;
  }>({ isOpen: false, details: undefined });

  const [locationsDetail, setLocationsDetail] = useState<
    | {
        isOpen: false;
        details: undefined;
      }
    | {
        isOpen: true;
        details: TransferReservationManagementListModel;
      }
  >({ isOpen: false, details: undefined });

  const [travelCanceledInfo, setCanceledTravelInfo] =
    useState<ViajeTrasladosGestionEstado>();
  const [showTravelCanceledInfo, setShowTravelCanceledInfo] =
    useState<boolean>(false);
  const tavelCanceledInfoDateTime = travelCanceledInfo?.datetime.split(' ');

  const [openEditLLtPais, setOpenEditLLtPais] = useState<boolean>(false);
  const [selectedReservation, setSelectedReservation] = useState<
    TransferReservationManagmentModel | undefined
  >(undefined);

  const [isOpenBusesPreAssignModal, setIsOpenBusesPreAssignModal] =
    useState<boolean>(false);
  const driverRepository = useChoferes();

  const [optionsBuses, setOptionsBuses] = useState<BusType[]>([]);
  const busesRequest = useRef<Promise<BusType[]> | null>(null);
  const driversRequest = useRef<Promise<ChoferPartialModel[]> | null>(null);

  const driversQuery = useSuperQuery(driverRepository.getDriversThatCanWork, {
    showSpinner: false,
    automaticFetch: false
  });

  const [isLoadingDriversCanWork, setIsLoadingDriversCanWork] =
    useState<boolean>(false);
  const [driversCanWork, setDriversCanWork] = useState<ChoferPartialModel[]>(
    []
  );

  const loadDriversCanWork = () => {
    if (!driversRequest.current) {
      setIsLoadingDriversCanWork(true);
      driversRequest.current = driverRepository
        .getDriversThatCanWork()
        .then((drivers) => {
          if (mounted.current) setDriversCanWork(drivers);
          return drivers;
        })
        .catch((error) => {
          driversRequest.current = null;
          throw error;
        })
        .finally(() => {
          if (mounted.current) setIsLoadingDriversCanWork(false);
        });
    }
    return driversRequest.current;
  };

  const onCloseBusesPreAssignModal = useCallback(() => {
    setIsOpenBusesPreAssignModal(false);
  }, []);

  const copyReservation = async (
    reservation: TransferReservationManagementListModel
  ) => {
    transferReservationCopy.copy(reservation.id);
  };

  const onCloseShowInfo = () => {
    setShowTravelCanceledInfo(false);
  };

  const getOptionsBuses = useCallback(() => {
    if (!busesRequest.current) {
      busesRequest.current = ViajeTrasladoService.getOptionsBuses()
        .then((buses) => {
          if (mounted.current) setOptionsBuses(buses);
          return buses;
        })
        .catch((error) => {
          busesRequest.current = null;
          throw error;
        });
    }
    return busesRequest.current;
  }, [ViajeTrasladoService]);

  const openReservationDetails = async (
    reservationId: number,
    modal: 'driver' | 'buses' | 'lltpais',
    driverId?: number
  ) => {
    const requestId = ++detailRequest.current;
    setLoadingDetail(true);
    try {
      const [reservation] = await Promise.all([
        ViajeTrasladoService.getManagementDetail(reservationId),
        modal === 'buses'
          ? loadDriversCanWork()
          : Promise.resolve<ChoferPartialModel[]>([]),
        modal === 'buses' ? getOptionsBuses() : Promise.resolve<BusType[]>([])
      ] as const);
      if (requestId !== detailRequest.current || !mounted.current) return;

      if (modal === 'driver') {
        const driver = [
          reservation.preAssignedDriver,
          reservation.assigned_driver
        ].find((candidate) => candidate && candidate.id === driverId);
        if (!driver)
          throw new Error('El servicio no tiene un chofer seleccionado.');
        setDriverDetail({
          isOpen: true,
          details: driver,
          busVehicle:
            reservation.serviceType ===
            ViajeTrasladoTipoServicio.SERVICIOS_GRUPALES
              ? reservation.bus_requirement?.vehicle
              : undefined
        });
      } else {
        setSelectedReservation(reservation);
        if (modal === 'buses') setIsOpenBusesPreAssignModal(true);
        else setOpenEditLLtPais(true);
      }
    } catch (error) {
      if (requestId === detailRequest.current && mounted.current) {
        snackbar.enqueueSnackbar(
          error instanceof Error
            ? error.message
            : 'No se pudo cargar el detalle.',
          { variant: 'error' }
        );
      }
    } finally {
      if (requestId === detailRequest.current && mounted.current)
        setLoadingDetail(false);
    }
  };

  useEffect(() => {
    if (!showTravelCanceledInfo) {
      setCanceledTravelInfo(undefined);
    }
  }, [showTravelCanceledInfo]);

  useEffect(() => {
    if (travelCanceledInfo) {
      setShowTravelCanceledInfo(true);
    }
  }, [travelCanceledInfo]);

  useEffect(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
    };
  }, []);

  useEffect(() => {
    if (showFilters) {
      getOptionsBuses().catch(() => {
        if (mounted.current)
          snackbar.enqueueSnackbar('No se pudieron cargar los tipos de bus.', {
            variant: 'error'
          });
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showFilters]);

  return (
    <div
      ref={tableRef}
      className="min-h-screen bg-page-light dark:bg-page-dark w-fit"
    >
      <PageHeader area="Operaciones - C.D.R." title="Gestión Integral" />
      <PageContainer lessMargin>
        <div className="flex w-full flex-col">
          <div
            className="sticky bg-page-light dark:bg-page-dark pr-4"
            style={{
              top: '0px',
              left: '0px',
              zIndex: 2,
              width: 'calc(100vw - 160px)'
            }}
          >
            <TableToolbar
              className="flex w-full mt-2 bg-page-light dark:bg-page-dark"
              chips={
                <ChipsBar
                  filters={filters}
                  defaultFilters={getDefaultFilters()}
                  onFiltersChange={onFiltersChange}
                />
              }
              actions={
                <>
                  <DownloadTravelsXlsx filters={filters} />
                  <SearchList
                    value={filters.search}
                    onSearch={onSearchChange}
                  />
                  <RefreshList
                    onRefreshTable={() => reload()}
                    isRefreshing={gestionReserves.isLoading}
                  />
                  <ColumnSelector
                    columns={columnVisibility}
                    onChange={setColumnVisibility}
                    columnLabels={columnsLabels}
                  />
                  <FiltersButton
                    onClick={() => setShowFilters(true)}
                    isActive={showFilters}
                  />
                </>
              }
            />
          </div>
          <FiltersDrawer
            open={showFilters}
            onClose={() => setShowFilters(false)}
            onClear={() => onFiltersChange(getDefaultFilters())}
          >
            <ViajeTrasladoBaseFilters
              onSubmit={async (filters) => onFiltersChange(filters)}
              initialValues={filters}
              filterByClient
              optionsBuses={optionsBuses}
            />
          </FiltersDrawer>

          {gestionReserves.error && (
            <div
              role="alert"
              className="flex items-center gap-3 p-4 text-red-600"
            >
              <span>
                No se pudo cargar Gestión: {gestionReserves.error.message}
              </span>
              <Button onClick={() => reload()}>Reintentar</Button>
            </div>
          )}
          <ViajeTrasladoGestionTable
            tableQuery={gestionReserves}
            handlePageChange={createTableScrollHandler(tableRef)}
            columnVisibility={columnVisibility}
            onChangePage={onChangePage}
            onChangeRowsPerPage={onChangeRowsPerPage}
            onSortChange={onSortChange}
            onLocationsDetails={(reservation) =>
              setLocationsDetail({ isOpen: true, details: reservation })
            }
            onReservationCopy={copyReservation}
            onReservationShowDetails={(id) => (
              <Link to={'/main/operations/trip-details/' + id}>
                <Button> Detalle </Button>
              </Link>
            )}
            setCanceledTravelInfo={(info) => {
              setCanceledTravelInfo(info);
            }}
            onOpenEditLLtPais={(reservation) => {
              openReservationDetails(reservation.id, 'lltpais');
            }}
            onBusesPreAssign={(travel) => {
              openReservationDetails(travel.id, 'buses');
            }}
            onShowDriverDetails={(reservationId, driverId) => {
              openReservationDetails(reservationId, 'driver', driverId);
            }}
          />
        </div>
      </PageContainer>
      {locationsDetail.details && (
        <ViajeTrasladoResumenModal
          isOpen={locationsDetail.isOpen}
          reservation={locationsDetail.details!}
          handleClose={() =>
            setLocationsDetail({ isOpen: false, details: undefined })
          }
        />
      )}

      {travelCanceledInfo ? (
        <ViajeTrasladoInfoCancelado
          travelCanceledInfo={travelCanceledInfo as ViajeTrasladosGestionEstado}
          onCloseShowInfo={onCloseShowInfo}
          showTravelCanceledInfo={showTravelCanceledInfo}
          date={moment(
            tavelCanceledInfoDateTime ? tavelCanceledInfoDateTime[0] : ''
          ).format('D/M/YY')}
          time={tavelCanceledInfoDateTime ? tavelCanceledInfoDateTime[1] : ''}
        />
      ) : null}
      {openEditLLtPais && (
        <EditLLTPais
          isOpen={openEditLLtPais}
          handleClose={() => {
            setOpenEditLLtPais(false);
            setSelectedReservation(undefined);
          }}
          onEditSuccess={() => {
            setOpenEditLLtPais(false);
            setSelectedReservation(undefined);
            reload();
          }}
          travel={selectedReservation}
        />
      )}

      {isOpenBusesPreAssignModal && (
        <BusesPreAssignModal
          isOpen={isOpenBusesPreAssignModal}
          travel={selectedReservation}
          optionsBuses={optionsBuses}
          driversQuery={{
            ...driversQuery,
            data: driversCanWork.filter(
              (driver) =>
                driver?.businessUnit?.name ===
                ViajeTrasladoTipoServicio.SERVICIOS_GRUPALES
            ),
            isLoading: isLoadingDriversCanWork
          }}
          handleClose={onCloseBusesPreAssignModal}
          onSuccesPreAssign={() => reload()}
        />
      )}
      <Dialog
        open={loadingDetail}
        onClose={() => {
          detailRequest.current++;
          setLoadingDetail(false);
        }}
      >
        <div className="flex items-center gap-3 p-6">
          <CircularProgress size={24} />
          <span>Cargando detalle…</span>
        </div>
      </Dialog>
      <Dialog
        open={driverDetail.isOpen}
        onClose={() => setDriverDetail({ details: undefined, isOpen: false })}
        maxWidth="md"
      >
        {driverDetail.details && (
          <DriverCanWorkDetails
            driver={driverDetail.details}
            busVehicle={driverDetail.busVehicle}
          />
        )}
      </Dialog>
    </div>
  );
};

export default ViajeTrasladoGestionPage;
